<template>
  <Cleave
    @input="updateData"
    :value="value"
    :placeholder="$t(placeholder)"
    :disabled="disabled"
    :class="{
      'cleave-error': errors.length > 0,
      'text-right': type === 'currency' || type === 'numeral',
    }"
    class="form-control"
    :raw="true"
    :options="options"
  />
</template>

<script>
import Cleave from "vue-cleave-component";
export default {
  components: {
    Cleave,
  },

  data() {
    return {
      currentValue: "",
    };
  },
  methods: {
    updateData(v) {
      console.log(v, "2999");
      if (this.type === "currency" && typeof v !== "numeral") {
        this.$emit("input", Number(v));
      } else {
        if(this.cleaveOptions?.isNumberPositive &&  v === "-"){
          this.$emit("input", 0);
        
        }else{
          this.$emit("input", v);
        }
      }
    },
  },
  /*  watch: {
    value(v) {
      this.currentValue = v;
    },
    currentValue(v){
      if (this.type === "currency" && typeof(v)!== "number") {
        this.$emit("input", Number(v));
      } else {
        this.$emit("input", v);
      }
    }
  }, */

  computed: {
    options() {
      if (this.type === "currency") {
        return this.inputMaskByCurrency(null, this.cleaveOptions?.isNumberPositive);
      } else if (this.type === "uppercase") {
        return { uppercase: true, blocks: [9999, 100000] };
      } else if (this.type === "numeral") {
      
        return {     
          numeral: true,

        };
      } else if (this.type === "credit-card") {
        return { creditCard: true };
      } else if (this.type === "exp-date") {
        return {
          date: true,
          datePattern: ["m", "y"],
          delimiter: "/",
        };
      }
    },
  },
  mounted() {
    if (this.defaultValue || this.defaultValue == 0) {
      this.currentValue = this.defaultValue;
    }
    if (this.value) {
      this.currentValue = this.value;
    }
  },
  name: "WidgetCleave",
  props: {
    errors: {
      type: Array,
      default() {
        return [];
      },
    },
    cleaveOptions: {
      type: Object,
      default() {
        return {};
      },
    },
    defaultValue: [Number, String],
    value: [Number, String],
    disabled: [Boolean, String, Number],
    type: String,
    placeholder: {
      type: String,
      default: "",
    },
  },
};
</script>
